/** Namespace `branding` — wird befüllt während der Komponenten-Migration. */
export const branding = {
  de: {
    branding: {
      saving: 'Speichere…',
      identityTitle: 'Praxis-Identität',
      identityDescription: 'Logo und Name werden in der Sidebar und im Header angezeigt.',
      practiceName: 'Praxis-Name',
      practiceNameHint: 'Erscheint in der Sidebar oben links und im Sidebar-Footer.',
      headerText: 'Header-Text',
      headerTextHint: 'Kleine Zeile über dem Seitentitel im Header (z.B. „Appointment Manager"). Leer lassen um auszublenden.',
      logo: 'Logo',
      chooseFile: 'Datei auswählen',
      orDragHere: 'oder hierher ziehen',
      logoFormats: 'PNG / JPG / SVG / WebP, max. 500 KB',
      currentLogoAlt: 'Aktuelles Logo',
      noLogo: 'kein Logo',
      removeLogo: 'Logo entfernen',
      colorSchemeTitle: 'Farbschema',
      colorSchemeDescription: 'Wirkt sofort — Vorschau direkt in der Sidebar/Header.',
      activeBadge: 'Aktiv',
      presetMediterranean: 'Navy + Mint — der Praxis-Default.',
      presetSlatePro: 'Slate + Sky — klinisch, neutral.',
      presetForest: 'Emerald + Lime — warm, organisch.',
      presetPlum: 'Violet + Fuchsia — premium, distinct.',
      mode: 'Modus',
      modeLight: 'Light',
      modeDark: 'Dark',
      modeAuto: 'Auto',
      modeLightHint: 'Heller Hintergrund',
      modeDarkHint: 'Dunkler Hintergrund',
      modeAutoHint: 'Folgt dem System',
      modeAutoNote: 'Auto folgt der Systemeinstellung deines Geräts (prefers-color-scheme).',
      // Toasts / Fehler
      nameSaved: 'Name gespeichert.',
      taglineSaved: 'Header-Text gespeichert.',
      themeApplied: 'Theme: {{preset}}.',
      logoUploaded: 'Logo hochgeladen.',
      logoRemoved: 'Logo entfernt.',
      errorNameEmpty: 'Name darf nicht leer sein.',
      errorSave: 'Speichern fehlgeschlagen.',
      errorThemeChange: 'Theme-Wechsel fehlgeschlagen.',
      errorModeChange: 'Mode-Wechsel fehlgeschlagen.',
      errorLogoSize: 'Logo darf maximal 500 KB groß sein.',
      errorUpload: 'Upload fehlgeschlagen.',
      errorRemove: 'Entfernen fehlgeschlagen.',
    },
  },
  es: {
    branding: {
      saving: 'Guardando…',
      identityTitle: 'Identidad de la clínica',
      identityDescription: 'El logotipo y el nombre se muestran en la barra lateral y en el encabezado.',
      practiceName: 'Nombre de la clínica',
      practiceNameHint: 'Aparece en la parte superior izquierda de la barra lateral y en el pie de la barra lateral.',
      headerText: 'Texto del encabezado',
      headerTextHint: 'Pequeña línea encima del título de la página en el encabezado (p. ej., «Appointment Manager»). Déjelo vacío para ocultarlo.',
      logo: 'Logotipo',
      chooseFile: 'Seleccionar archivo',
      orDragHere: 'o arrástrelo aquí',
      logoFormats: 'PNG / JPG / SVG / WebP, máx. 500 KB',
      currentLogoAlt: 'Logotipo actual',
      noLogo: 'sin logotipo',
      removeLogo: 'Eliminar logotipo',
      colorSchemeTitle: 'Esquema de color',
      colorSchemeDescription: 'Se aplica de inmediato: vista previa directamente en la barra lateral y el encabezado.',
      activeBadge: 'Activo',
      presetMediterranean: 'Azul marino + menta: el valor predeterminado de la clínica.',
      presetSlatePro: 'Pizarra + cielo: clínico, neutro.',
      presetForest: 'Esmeralda + lima: cálido, orgánico.',
      presetPlum: 'Violeta + fucsia: premium, distintivo.',
      mode: 'Modo',
      modeLight: 'Claro',
      modeDark: 'Oscuro',
      modeAuto: 'Automático',
      modeLightHint: 'Fondo claro',
      modeDarkHint: 'Fondo oscuro',
      modeAutoHint: 'Sigue el sistema',
      modeAutoNote: 'El modo automático sigue la configuración del sistema de su dispositivo (prefers-color-scheme).',
      // Toasts / Errores
      nameSaved: 'Nombre guardado.',
      taglineSaved: 'Texto del encabezado guardado.',
      themeApplied: 'Tema: {{preset}}.',
      logoUploaded: 'Logotipo subido.',
      logoRemoved: 'Logotipo eliminado.',
      errorNameEmpty: 'El nombre no puede estar vacío.',
      errorSave: 'Error al guardar.',
      errorThemeChange: 'Error al cambiar el tema.',
      errorModeChange: 'Error al cambiar el modo.',
      errorLogoSize: 'El logotipo no puede superar los 500 KB.',
      errorUpload: 'Error al subir.',
      errorRemove: 'Error al eliminar.',
    },
  },
};
